<dx-popup
    #ownerWelcomeLetterPopup
    title="Welcome Letter"
    [showTitle]="true"
    width="30%"
    height="45%"
    [resizeEnabled]="true"
    [(visible)]="visible"
    (onHidden)="onHidden($event)"
>
    <div *dxTemplate="let item of 'content'" class="owner-welcome-letter-content">
        <dx-box width="100%" height="100%" direction="col">
            <dxi-item [ratio]="1">
                <div class="welcome-letter-text">For Owners only. Do not use to send letters to Tenants.</div>
                <div class="welcome-letter-text">
                    This feature may be used to send New Homeowner Welcome Letters shortly after we process the
                    Homeowner's conveyance.
                </div>
                <div class="welcome-letter-text">
                    If you notice a problem with the New Homeowner Welcome Letter for this community or owner, please
                    contact fulfillment@ciramail.com.
                </div>

                <div *ngIf="!!welcomeLettorEditorData && welcomeLettorEditorData.lastPrintedDate">
                    <p class="cc-text-required">
                        A welcome letter was already sent for this property on
                        {{ welcomeLettorEditorData.lastPrintedDate | date }}. Please be sure you want to send another
                        one.
                    </p>
                </div>

                <div class="send-by-mail">
                    <dx-check-box
                        [disabled]="!welcomeLettorEditorData?.allowSendByMail"
                        [(value)]="sendByMail"
                        text="Send By Mail"
                    ></dx-check-box>
                </div>
                <div class="send-by-mail">
                    <dx-check-box
                        [disabled]="!welcomeLettorEditorData?.allowSendByEmail"
                        [(value)]="sendByEmail"
                        text="Send By Email"
                    ></dx-check-box>
                </div>
            </dxi-item>

            <dxi-item baseSize="auto">
                <dx-toolbar width="100%">
                    <dxi-item location="before">
                        <div *dxTemplate>
                            <dx-button
                                type="default"
                                text="Cancel"
                                [icon]="iconCancel"
                                (onClick)="onHidden($event)"
                            ></dx-button>
                        </div>
                    </dxi-item>

                    <dxi-item location="after">
                        <div *dxTemplate>
                            <dx-button
                                type="default"
                                text="Preview"
                                [icon]="iconSearch"
                                (onClick)="onPreviewClick($event)"
                            ></dx-button>
                        </div>
                    </dxi-item>
                    <dxi-item location="after">
                        <div *dxTemplate>
                            <dx-button
                                type="success"
                                text="Submit"
                                [icon]="iconCheck"
                                [disabled]="!sendByMail && !sendByEmail"
                                (onClick)="onSubmitClick()"
                            ></dx-button>
                        </div>
                    </dxi-item>
                </dx-toolbar>
            </dxi-item>
        </dx-box>
    </div>
</dx-popup>

<dx-load-panel
    [position]="{ of: '#ownerWelcomeLetterPopup' }"
    *ngIf="loadingVisible"
    [visible]="loadingVisible"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    [closeOnOutsideClick]="false"
></dx-load-panel>
